"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const storage_adapter_1 = require("./storage-adapter");
class ExpiringStorage extends storage_adapter_1.default {
    constructor(storageKey, daysToStore = 365) {
        super(storageKey, storage_adapter_1.default.types.LOCAL_STORAGE);
        this.daysToStore = daysToStore;
    }
    writeEntry(item_ = {}) {
        const date = new Date();
        date.setDate(date.getDate() + this.daysToStore);
        const itemToStore = {
            expires: date.toDateString(),
            value: item_,
        };
        const success = super.writeEntry(itemToStore);
        return success;
    }
    readEntry() {
        const entry = super.readEntry();
        if (ExpiringStorage.entryIsExpired(entry)) {
            console.warn(`Entry'${entry.value}' is expired`, entry);
            return null;
        }
        return entry && entry.value ? entry.value : null;
    }
    static entryIsExpired(item_) {
        return item_ && item_.expires ? ExpiringStorage.dateStringIsExpired(item_.expires) : false;
    }
    static dateStringIsExpired(dateString) {
        const expiringMillisecs = dateString && Date.parse(dateString) ? Date.parse(dateString) : 0;
        const dateMillisecondsNow = new Date().getTime();
        return expiringMillisecs && expiringMillisecs - dateMillisecondsNow <= 0;
    }
}
exports.default = ExpiringStorage;
//# sourceMappingURL=expiring-storage.js.map